var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-gy",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#399408",
    d: "M2.4 0H640v480H2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.2 0c-.9 0 619.6 241.5 619.6 241.5L0 479.8.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffde08",
    d: "M.3 20.2c3.4 0 559 217.9 555.9 220L1.9 463.2.3 20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9.8c1.8 0 290.9 240.9 290.9 240.9L1.8 477V.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2110",
    d: "M.3 33.9c1.6-15 260.9 208.4 260.9 208.4L.2 451.7V33.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGy);
export default __webpack_public_path__ + "static/media/gy.3b4904b139fc14539fa0a8abacb5c8d6.svg";
export { ForwardRef as ReactComponent };